import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AlertDTO } from '../types/alertDTO'

export const ALERT_FRAGMENT: TypedDocumentNode<AlertDTO> = gql`
  fragment AlertFragment on Alert {
    name
    description
  }
`
